import CourseTableGrid from "./courseTableGrid"
export default CourseTableGrid;